/*
 * Running total in the Add to Cart button.
 *
 * (Variant price + data-extra-cents) x quantity. The ID tag checkbox sets
 * that attribute and fires atc-total:refresh; with no upsell on the page the
 * extra is simply absent. Stylux adds one tag per unit, so the surcharge
 * scales with quantity. Sold-out variants skip the suffix so the button is
 * just "Sold out". The sticky bar shows the same combined amount on its
 * price, not a suffix. Toggled by the "Show total in Add to Cart button"
 * setting on the buy_buttons block — when it is off the main suffix is
 * absent but the sticky price still updates.
 *
 * The span is re-queried on every use and both listeners are delegated from
 * document, so this survives the partial section re-renders product-info.js
 * does on variant change.
 */
(function () {
  var variantPrice = null; // cents; seeded from the markup on first read

  function totalEls() {
    return document.querySelectorAll('[data-atc-total]');
  }

  function totalEl() {
    return document.querySelector('[data-atc-total]');
  }

  function quantity() {
    var input = document.querySelector('.product-form__quantity input[name="quantity"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  function money(cents) {
    if (window.mon && typeof window.mon.formatMoney === 'function') {
      return window.mon.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function variantPriceCents() {
    if (variantPrice !== null) return variantPrice;
    var el = totalEl();
    var seed = el ? parseInt(el.getAttribute('data-variant-price'), 10) : NaN;
    variantPrice = isNaN(seed) ? 0 : seed;
    return variantPrice;
  }

  function extraCents() {
    var el = document.querySelector('[data-atc-total][data-extra-cents], [data-id-tag-upsell][data-extra-cents]');
    var extra = el ? parseInt(el.getAttribute('data-extra-cents'), 10) : NaN;
    return isNaN(extra) ? 0 : extra;
  }

  /* The picker JSON is the source of truth. Color-swatches fires variant:change
     on load with a different product's variant, so that event cannot be trusted
     on its own. */
  function selectedVariant() {
    var node = document.querySelector('variant-selects [data-selected-variant]');
    if (!node || !node.textContent) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function isSoldOut(eventVariant) {
    var variant = selectedVariant() || eventVariant;
    if (variant) return variant.available === false;
    var el = totalEl();
    var button = el && el.closest('.product-form__submit');
    if (button && (button.disabled || button.hasAttribute('disabled'))) return true;
    var label = button && button.querySelector('span:not([data-atc-total])');
    var text = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
    var strings = window.variantStrings || {};
    return !!(text && (text === strings.soldOut || text === strings.unavailable));
  }

  function renderSticky(cents) {
    var wrap = document.querySelector('.sticky-atc .flex-price');
    if (!wrap) return;
    var current = wrap.querySelector('.price--on-sale .price-item--sale')
      || wrap.querySelector('.price__regular .price-item--regular');
    if (current) current.textContent = money(cents);
  }

  function render(eventVariant) {
    var soldOut = isSoldOut(eventVariant);
    var cents = (variantPriceCents() + extraCents()) * quantity();
    var suffix = !soldOut && cents > 0 ? ' - ' + money(cents) : '';

    totalEls().forEach(function (el) {
      el.textContent = suffix;
      var button = el.closest('.product-form__submit');
      if (soldOut && button) button.setAttribute('disabled', 'disabled');
    });

    if (!soldOut) renderSticky(cents);
  }

  document.addEventListener('atc-total:refresh', function () {
    render();
  });

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (variant && typeof variant.price === 'number') {
      var selected = selectedVariant();
      if (!selected || selected.id === variant.id) variantPrice = variant.price;
    }
    render(variant);
  });

  /* QuantityInput in global.js dispatches a bubbling 'change' from the input
     when the +/- buttons are used, and the browser fires 'input' when the value
     is typed. Listen for both or the steppers do not move the total. */
  function onQuantityEvent(event) {
    var target = event.target;
    if (!target) return;
    if (target.name === 'quantity' || (target.classList && target.classList.contains('quantity__input'))) {
      render();
    }
  }

  document.addEventListener('input', onQuantityEvent);
  document.addEventListener('change', onQuantityEvent);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
